import "./App.scss";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "./Components/Layout/layout";
import Home from "./Components/Home/home";
import Services from "./Components/Services/services";
import Projects from "./Components/Projects/projects";
import About from "./Components/About/about";
import Contact from "./Components/Contact/contact";

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route exact="true" path="/" element={<Home />} />
          <Route exact="true" path="/services" element={<Services />} />
          <Route exact="true" path="/projects" element={<Projects />} />
          <Route exact="true" path="/about" element={<About />} />
          <Route exact="true" path="/contact" element={<Contact />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
